import { CanActivateFn } from '@angular/router';

export const mainGalleryCanMatchGuard: CanActivateFn = (route, state) => {
  const toMatch = ['advanced', 'embed', 'review', 'subscribe', 'unsubscribe', 'pwa', 'download'];

  let firstPart = state[1]?.path as string;

  if (['identify', 'not-found', 'access', 'error', 'maintenance'].includes(state[0]?.path)) {
    firstPart = state[2]?.path as string;
  }

  const interestingPathPart = firstPart as string;
  if (!interestingPathPart) return false; // /gal_abc
  if (interestingPathPart.startsWith('asset_')) return false; // asset page
  if (interestingPathPart.startsWith('img_')) return false; // legacy asset page
  if (toMatch.some(match => interestingPathPart === match)) return false;
  return true;
};
